/**
 * config.ts - API 基础配置
 *
 * 功能说明：
 * - API 基础 URL、超时时间等配置
 * - axios 实例创建
 *
 * 依赖关系：
 * - 被 api/index.ts 导入使用
 *
 * 关键注释索引：
 * - [axios实例] - 见下方 axios.create
 *
 * 创建日期：2026-05-03
 * 作者：AI Assistant
 */

import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

type DataReturningApiClient = Omit<AxiosInstance, 'get' | 'post' | 'put' | 'patch' | 'delete'> & {
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
};

/**
 * [axios实例] 创建 axios 实例
 *
 * @description 配置 API 的基础参数
 * - baseURL: API 基础路径（支持环境变量配置）
 * - timeout: 60秒超时（支持豆包 API 等慢响应场景）
 */
const axiosApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const api = axiosApi as DataReturningApiClient;
export default api;
